import _Vue from 'vue';
import Vuex from 'vuex';
import { BaseRepository, RepositoryPluginOptions } from './base-repository';
import { AuthenticationContext } from '@/plugins/msal';

import { crmapi } from '@/types/crm-types';

import '../plugins/string-extensions';

export class CrmRepository extends BaseRepository {
  public async getProjectsAsync(activeOnly: boolean): Promise<crmapi.Project[]> {
    return this.post<crmapi.Project[]>('/api/project/list', activeOnly);
  }

  public async getProjectAsync(id: string, startDate: Date | undefined, endDate: Date | undefined): Promise<crmapi.ProjectData> {
    return this.post<crmapi.ProjectData>(`/api/project/get/${id}`, {
      start: startDate ? startDate.toLocalDateString() : undefined,
      end: endDate ? endDate.toLocalDateString() : undefined,
    });
  }

  public async deleteTaskAsync(projectId: string, taskId: string): Promise<string> {
    return this.post<string>(`/api/project/deleteTask/${projectId}`, `"${taskId}"`);
  }

  public async createUpdateTaskAsync(projectId: string, task: crmapi.Task): Promise<crmapi.Task> {
    return this.post<crmapi.Task>(`/api/project/createUpdateTask/${projectId}`, task);
  }

  public async createUpdateDeleteTaskDayAsync(taskId: string, taskDay: crmapi.Day): Promise<crmapi.CreateUpdateDeleteTaskDay> {
    return this.simplepost<crmapi.CreateUpdateDeleteTaskDay>(`/api/project/createUpdateDeleteTaskDay/${taskId}`, taskDay);
  }

  public async getEmployeeAsync(employeeId: string, startDate?: Date, endDate?: Date): Promise<crmapi.Employee> {
    return this.post<crmapi.Employee>('/api/project/employee', {
      employeeId,
      start: startDate ? startDate.toLocalDateString() : undefined,
      end: endDate ? endDate.toLocalDateString() : undefined,
    });
  }

  public async getEmployees(): Promise<crmapi.Employee> {
    return this.post<crmapi.Employee>('/api/project/employees');
  }
}

export function CrmRepositoryPlugin(Vue: typeof _Vue, options: RepositoryPluginOptions): void {
  const repo = new CrmRepository(Vue.prototype.$msal as AuthenticationContext, options);
  Vue.prototype.$crmApi = repo;
  (Vuex.Store.prototype as any).$crmApi = repo;
}

declare module 'vue/types/vue' {
  interface Vue {
    $crmApi: CrmRepository;
  }
}
